export default __webpack_public_path__ + "static/media/ok.0490d3d1.png";